import { Component, OnInit, OnDestroy } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationService } from '../../Services/location.service';
import { RBLocation } from '../../Models/Location';
import { VERBIAGE } from 'src/app/config';
import { NotificationService } from 'src/app/core/Services/notification.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialogRef } from '@angular/material';
import { RBTeamMember } from 'src/app/team/Models/Team';
import { TeamService } from 'src/app/team/Services/team.service';
import { MemberListBoxComponent } from 'src/app/core/Components/shared/member-listbox/member-listbox.component';

@Component({
    selector: 'location-detail',
    templateUrl: './location-detail.component.html',
    styleUrls: ['./location-detail.component.scss']
})

export class LocationDetailComponent implements OnInit, OnDestroy {
    private Location;
    constructor(
        private _shared: SharedService, private _ar: ActivatedRoute, private _location: LocationService,
        private _router: Router, private _notify: NotificationService, private _team: TeamService
    ) {
        // Show loader
        this._shared.loadingState = true;
    }

    async ngOnInit() {
        const id = +this._ar.snapshot.params.id;
        // Call location service for feching location by id
        this.Location = <RBLocation>await this._location.getLocationById(id);

        // Setting up page title
        this._shared.pageTitle = this.Location.locationName;

        // Set up page controls
        const _this = this;
        this._shared.pageControls = [
            { type: '-icon-', title: 'Previous page', icon: 'arrow_back', action() {
                // Navigate to locations list.
                _this._router.navigate(['/dashboard/locations']);
            }},
            { color: 'accent', type: '-icon-', title: 'Edit', icon: 'edit', action() {
                // Navigate to edit location.
                _this._router.navigate(['/dashboard/locations/edit', _this.Location.locationID]);
            }},
            { color: 'warn', type: '-icon-', title: 'Archive', icon: 'archive', action() {
                let body = (_this.Location.isRegional === 'Y') ? VERBIAGE.REGIONAL_SERVICE_CENTER_DELETE: VERBIAGE.SERVICE_CENTER_DELETE;
                _this._notify.openDialog({
                    color: 'warn', title: VERBIAGE.ARCHIVE_SERVICE_CENTER_TITLE, body, handlers: [
                        { color: 'warn', text: 'Confirm', type: '-raised-', action() {
                            // Archive from DB
                            _this.archiveServiceCenterInDB();
                        }},
                        { text: 'Cancel', type: '-raised-' }
                    ]
                });
            }}
        ];

        // Hide loader
        this._shared.loadingState = false;
    }

    archiveServiceCenterInDB(){
        // Archive service center in DB
        this._location.archiveServiceCenter(this.Location.locationID, this.Location.isRegional).subscribe(res => {
            if (res['status'] === 'OK') {
                this._notify.toastMessage({
                    color: 'warn', message: VERBIAGE.ARCHIVE_UPDATE_MESSAGE, duration: 3000
                });
                this._router.navigate(['/dashboard/locations']);
            }
        });
    }

    linkTeamMembers() {
        // Link team member
        let memberListBox: MatDialogRef<RBTeamMember[]>;
        this._team.getAllMembers().subscribe(res => {
            const teammembers = res['result'];
            this.Location['Team'].forEach((member) => {
                let index = teammembers.findIndex(x => x.teammemberID === member.teammemberID);
                teammembers.splice(index, 1);
            });

            // Capture dialog ref
            memberListBox = this._shared.openModal(MemberListBoxComponent, teammembers);

            memberListBox.afterClosed().subscribe((result: RBTeamMember[]) => {

                if (!result) {
                    return;
                }

                // Selected member returened 
                result.forEach(async (member) => {
                    let linked = await this._location.linkMemberToRegion(this.Location.regionID, member.teammemberID);
                    if (linked['status'] !== 'OK') {
                        this._notify.toastMessage({
                            color: 'warn', message: VERBIAGE.REGIONAL_TEAM_LINK_FAIL, duration: 3000
                        });
                    } else {
                        this.Location['Team'].push(member);
                    }
                });
            });
        });
    }

    unlinkTeammembers(regionID: number, member: RBTeamMember) {
        // Unlink teammember from Regional Service center
        const _this = this;
        this._notify.openDialog({
            color: 'warn', title: VERBIAGE.REGIONAL_TEAM_UNLINK_TITLE,
            body: `${VERBIAGE.REGIONAL_TEAM_UNLINK_BODY} <strong>${member.fullName}</strong>.`,
            handlers: [
                { text: 'Confirm', type: '-raised-', color: 'warn', action() {
                    // update visibility flag in DB
                    _this._location.unlinkMemberFromRegion(regionID, member.teammemberID).subscribe(res => {
                        if (res['status'] === 'OK') {
                            let index = _this.Location['Team'].findIndex(x => x.teammemberID === member.teammemberID);
                            _this.Location['Team'].splice(index, 1);
                        }
                    });
                }},
                { text: 'Cancel', type: '-raised-' }
            ]
        });
        // this._location.unlinkMemberFromRegion(regionID, teammemberID).subscribe(res => {
        //     if (res['status'] === 'OK') {

        //     }
        // })
    }

    membarVisibility(e, id: number, name: string) {
        // Teammember visibility update
        if (e.checked === false) {
            const _this = this;
            this._notify.openDialog({
                color: 'primary', title: VERBIAGE.VISIBILITY_TITLE,
                body: `${VERBIAGE.VISIBILITY_CONFIRMATION_MESSAGE} <strong>${name}</strong>.`,
                handlers: [
                    { text: 'Confirm', type: '-raised-', color: 'warn', action() {
                        e.source.checked = false;
                        // Update in DB
                        _this.updateMemberVisibilityInDB(id, e.source.checked);
                    }},
                    { text: 'Cancel', type: '-raised-', action() { e.source.checked = true; }}
                ]
            });
        } else {
            // Update in DB
            this.updateMemberVisibilityInDB(id, e.source.checked);
        }
    }

    updateMemberVisibilityInDB(id, flag) {
        // Call location service for visibility update
        const _this = this;
        this._location.updateMemberVisibility(this.Location.regionID, id, { visible: flag }).subscribe(res => {
            if (res['status'] === 'OK') {
                _this._notify.toastMessage({
                    color: 'accent', message: VERBIAGE.VISIBILITY_UPDATE_MESSAGE, duration: 3000
                });
            }
        });
    }

    reorderTeammembers(e) {
        // Reorder Team sequence
        moveItemInArray(this.Location['Team'], e.previousIndex, e.currentIndex);
        const newOrder = [];
        this.Location['Team'].forEach((val, index) => {
            newOrder.push({ teammemberID: val['teammemberID'], teammemberIndex: index+1});
        });

        this._location.updateTeamOrder(this.Location.regionID, newOrder).subscribe(res => {
            if (res['status'] === 'OK') {
                // No need for notification
            }
        });
    }

    ngOnDestroy() {
        // Remove page controls
        this._shared.pageControls = null;
    }
}